module.exports = __webpack_public_path__ + "static/media/IMG_5418.535d7a22.jpg";